import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import HeroAlt from "@/components/HeroAlt";
import ProblemSection from "@/components/home/ProblemSection";
import WhatWeBring from "@/components/home/WhatWeBring";
import Thesis from "@/components/home/Thesis";
import PortfolioSection from "@/components/home/PortfolioSection";
import TrackRecord from "@/components/home/TrackRecord";
import ArunIntro from "@/components/home/ArunIntro";
import FinalCTA from "@/components/home/FinalCTA";
import FooterAlt from "@/components/FooterAlt";
import StructuredData from "@/components/StructuredData";
import { setHeadMeta } from "@/lib/seo";

const Index = () => {
  useEffect(() => {
    setHeadMeta({
      title: "AMX Ventures | VC for AI Infrastructure, Sovereign & Physical AI",
      description:
        "AMX Ventures is an early-stage venture capital fund investing in AI infrastructure, sovereign AI and physical AI, with hyperscaler co-sell behind every cheque. Pitch us.",
      canonical: "https://amx.ventures",
      ogTitle: "AMX Ventures | VC for AI Infrastructure, Sovereign & Physical AI",
      ogDescription:
        "Early-stage venture capital fund investing in AI infrastructure, sovereign AI and physical AI, with hyperscaler co-sell behind every cheque.",
      ogType: "website",
    });
  }, []);

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://amx.ventures/#org",
    "name": "AMX Ventures",
    "url": "https://amx.ventures",
    "description":
      "Early-stage venture capital fund investing in AI infrastructure, sovereign AI and physical AI, with hyperscaler co-sell and enterprise access behind every cheque.",
    "email": "arun@amx.ventures",
    "foundingLocation": [
      { "@type": "Place", "name": "San Francisco" },
      { "@type": "Place", "name": "Dubai" }
    ],
    "areaServed": ["United States", "GCC", "United Arab Emirates"],
    "knowsAbout": [
      "Venture Capital",
      "AI Infrastructure",
      "Sovereign AI",
      "Physical AI",
      "Enterprise AI",
      "Microsoft co-sell"
    ],
    "founder": { "@id": "https://amx.ventures/arunmohan#person" },
    "sameAs": ["https://www.linkedin.com/in/arunmohansf", "https://x.com/arunmohansf"]
  };

  return (
    <div className="min-h-screen">
      <StructuredData data={organizationSchema} />
      <Navigation />
      <main>
        <HeroAlt />
        <ProblemSection />
        <WhatWeBring />
        <Thesis />
        <PortfolioSection />
        <TrackRecord />
        <ArunIntro />
        <FinalCTA />
      </main>
      <FooterAlt />
    </div>
  );
};

export default Index;
